import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { GlobalSettings } from '../../../core/models/globalSettings';

import { EquipmentService } from '../../../core/services/equipment.service';

@Component({
    selector: 'app-equipment-create-name-modal',
    templateUrl: './equipment-create-name-modal.component.html',
    styleUrls: ['./equipment-create-name-modal.component.scss'],
    standalone: false
})
export class EquipmentCreateNameModalComponent {

	public formGroup: FormGroup<{ name: FormControl<string> }>;

	protected readonly MORE_SYMBOL_VALIDATION: number = GlobalSettings.MORE_SYMBOL_VALIDATION;

	constructor(
		private dialogRef: MatDialogRef<EquipmentCreateNameModalComponent>,
		private equipmentService: EquipmentService
	) {
		this.formGroup = new FormGroup<{ name: FormControl<string> }>({
			name: new FormControl<string>(
				'',
				[Validators.required, Validators.maxLength(this.MORE_SYMBOL_VALIDATION)],
				[this.equipmentService.nameUniqueValidator()]
			)
		});
	}

	apply() {
		if (this.formGroup.valid) return this.dialogRef.close({ name: this.formGroup.controls.name.value });
	}

	close(): void {
		this.dialogRef.close();
	}
}